module.exports = __webpack_public_path__ + "img/3fca848aa9dac8aecc9049cccc9e45e8.8e32de04.png";